export default function (data, parent, field) {
  var self = this;
  var r = Kadenze.Util.objFromString;
  var default_er = {value: true, notes: false};
  var $container;
  var name = null;

  self.id = ko.observable(r(data, 'id', null));
  self.dom_id = ko.observable('gconfig-' + (self.id() || 'new-' + _.random(100)));
  self.coursework_id = ko.computed(function() {
    return r(data, 'coursework_id', parent.coursework() ? parent.coursework().id() : null);
  });
  self.is_draft_course = ko.computed(function() {
    return parent.coursework() ? (parent.coursework().course.is_draft()) : false;
  });
  self.coursework_field_id = ko.computed(function() {
    return r(data, 'coursework_field_id', field ? field.id() : null);
  });
  self.name = ko.observable(r(data, 'name', name)).extend({required: true });
  self.description = ko.observable(r(data, 'description', null));
  self.auto_grader_id = ko.computed(function() {
    return field ? field.auto_grader_id() : r(data, 'auto_grader_id', null);
  });
  self.scope = ko.observable('autograder');
  self.ag_parameters = ko.mapping.fromJS(r(data, 'ag_parameters', []));
  self.ag_config_id = ko.observable(r(data, 'ag_config_id', null));
  self.ag_config_id.subscribe(function() {
    self.setupAGParams();
  });

  self.editing = ko.observable(r(data, 'editing', false)); //This will keep the question panel open if true
  self._destroy = ko.observable(r(data, '_destroy', false));

  self.keysToWatch = ['name', 'description'];
  self.snapshot = {};
  $container = $('#js-cw-step3');

  self.setupAGParams = function() {
    self.ag_parameters([]);
    if (self.auto_grader_id() && self.ag_config_id()) {
      var configuration = field.getConfigurationDetails(self.ag_config_id());
      var ag_param = {
        name: configuration.name,
        config_id: configuration.config_id,
        value: '',
        type: configuration.type
      };
      if (configuration.options) {
        ag_param.options = configuration.options;
      }
      self.ag_parameters.push(ko.mapping.fromJS(ag_param));
    }
  };

  self.injectAGParamValues = function() {
    if (self.ag_parameters()) {
      _.each(self.ag_parameters(), function(param) {
        if (typeof param.value == 'undefined') {
          param.value = ko.observable('');
        }
      });
    }
  };

  self.takeSnapshot = function() {
    //TODO: Fix entry_requirements snap-shooting
    _.each(self.keysToWatch, function(key) { self.snapshot[key] = _.isObject(self[key]()) ? self[key]().toString() : self[key](); });
  };

  self.restoreSnapshot = function() {
    _.each(self.keysToWatch, function(key) {
      if (_.has(self.snapshot, key))
        self[key](self.snapshot[key]);
    });
  };

  self.resetSnapshot = function() {
    self.snapshot = {};
  };

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self), function(key) {
      if (ko.isObservable(self[key])) {
        propsToValidate.push(self[key]);
      }
    });
    var errors = ko.validation.group(propsToValidate);
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0;
  };

  self.initEditorUI = function() {
    Kadenze.UIUtil.initExpandableTextareas();
  };

  self.toggleEditor = function() {
    if (!self.editing()) {
      self.takeSnapshot();
      self.initEditorUI();
    }
    var $row = $('#' + self.dom_id());
    var $editRow = $('.display-table__edit_row', $row);
    $row.toggleClass('collapsed');
    $row.toggleClass('expanded');
    $editRow.collapse('toggle');
    self.editing(!self.editing());
  };

  self.destroy = function(item, event) {
    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this configuration?', function() {
      self._destroy(true);
      var response = parent.save($container);
    });
    event.stopPropagation();
  };

  self.add = function(item, event) {
    if (item.isValid()) {
      parent.coursework().grading_configurations.push(item);
      var response = parent.save($container);
      response.success(function() {
        parent.newConfiguration(false);
      });
      response.error(function (xhr, textStatus, errorThrown) {
        parent.coursework().grading_configurations.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.addToField = function(item, event) {
    if (item.isValid()) {
      field.grading_configurations.push(item);
      var response = parent.save($container);
      response.success(function() {
        parent.newConfiguration(false);
      });
      response.error(function (xhr, textStatus, errorThrown) {
        field.grading_configurations.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.update = function(item, event) {
    if (self.isValid()) {
      var response = parent.save($container);
      response.success(function() {
        self.resetSnapshot();
      });
      response.error(function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.cancel = function(item, event) {
    if (parent.newConfiguration()) {
      parent.newConfiguration(false);
    } else {
      self.restoreSnapshot();
      self.toggleEditor();
    }
  };

  // If for some reason a value attr didn't get saved inside one of the ag_parameters,
  // inject a value observable during run-time to prevent breaking the UI
  self.injectAGParamValues();

  return self;
}
